import { useNavigate } from "@tanstack/react-router"

import { SegmentedControl } from "../ui/segmented-control"
import { useSearchMarketplaces } from "../../services/use-search-rankings"

/**
 * Swaps the keyword overview between marketplaces — `/keywords/emag-ro` ⇄
 * `/keywords/allegro-pl`.
 *
 * A mode switch rather than a filter: the two marketplaces track different
 * phrases in different languages, so the tables share no rows and there is
 * nothing to filter. Which segments exist is the API's answer, so a third
 * marketplace config appears here without a code change.
 *
 * Renders nothing when only one marketplace is configured — a control with a
 * single option cannot change anything, and an always-on segment reads as a
 * filter that is stuck.
 */
export function SearchRankingMarketplaceSwitch({ marketplace }: { marketplace: string }) {
  const marketplaces = useSearchMarketplaces()
  const navigate = useNavigate()
  const options = (marketplaces.data ?? []).map(({ id, name }) => ({ value: id, label: name }))

  if (options.length < 2) {
    return null
  }

  return (
    <SegmentedControl
      options={options}
      value={marketplace}
      onChange={(next) => {
        if (next !== marketplace) {
          void navigate({ to: "/keywords/$marketplace", params: { marketplace: next } })
        }
      }}
      label="Marketplace"
      className="shrink-0"
    />
  )
}
